import {
  Autocomplete,
  AutocompleteItem,
  AutocompleteProps,
} from "@heroui/react";
import { TicketPriority } from "@/api/tickets/tickets";

export interface Priority {
  key: TicketPriority;
  display_name: string;
}

export function PriorityHandbook(props: AutocompleteProps<Priority>) {
  const items: Priority[] = [
    { key: "low", display_name: "Низкий" },
    { key: "medium", display_name: "Средний" },
    { key: "high", display_name: "Высокий" },
    { key: "urgent", display_name: "Срочный" },
  ];

  return (
    <Autocomplete
      defaultItems={items}
      label="Приоритет"
      placeholder="Выберите приоритет"
      variant="bordered"
      {...props}
    >
      {(item) => (
        <AutocompleteItem key={item.key}>{item.display_name}</AutocompleteItem>
      )}
    </Autocomplete>
  );
}
